import React from 'react';
import { useT } from '../context/LangContext';
import JinglePlayer from './JinglePlayer';
import PartnerLockup from './PartnerLockup';

/**
 * ProgrammeContext — calm editorial band. Houses:
 *   · About Grow Your Tomorrow
 *   · AGRA + Mastercard Foundation partner lockup
 *   · "This is what tomorrow sounds like" jingle player
 *
 * (About YEFFA has been promoted to its own section directly under the hero.)
 */
export default function ProgrammeContext() {
  const t = useT();

  return (
    <section
      className="section-rhythm bg-[#FBFAF5] border-y border-[#07743F]/8"
      data-testid="programme-context"
      aria-labelledby="programme-context-heading"
    >
      <div className="container mx-auto px-4">
        <div className="max-w-5xl">

          <div className="flex items-center gap-3 mb-6">
            <span className="w-2 h-7 bg-[#E4E517] rounded-full" aria-hidden="true" />
            <p
              id="programme-context-heading"
              className="kicker text-[#72BF44]"
            >
              {t('context.eyebrow', 'Programme context')}
            </p>
          </div>

          <div data-testid="context-about-gyt" className="mb-12">
            <h2 className="display-section text-3xl md:text-4xl lg:text-5xl text-[#07743F] mb-6 max-w-3xl">
              {t('context.gyt.title', 'About Grow Your Tomorrow')}
            </h2>
            <p className="body-prose prose-hang text-[15px] md:text-[16px] text-[#58595B]">
              {t('context.gyt.body',
                "Grow Your Tomorrow is YEFFA's storytelling platform. It provides young people, partners and programme participants with a space to share their experiences, innovations, challenges and successes. These stories help amplify youth voices, showcase impact, inform learning, and contribute to advocacy, policy and investment conversations shaping Africa's food systems.")}
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-8 lg:gap-12 items-stretch pt-10 border-t border-[#07743F]/12">
            <div className="flex items-center" data-testid="context-partner-lockup">
              <PartnerLockup variant="default" size="md" />
            </div>
            <div className="flex items-center">
              <div className="w-full">
                <JinglePlayer />
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}
